module.exports = __webpack_public_path__ + "static/media/in.7fdfdb85.svg";